import React from 'react';
import { useSelector } from 'react-redux';

import { useTranslation } from 'hooks';
import { BookingFlowLoadingIndicator } from 'BookingFlow/components';
import ThemeContextProvider, { THEMES } from 'contexts/ThemeContext';
import { selectProfile } from 'store/profile';
import YourInterests from '../ProfileView/YourInterests';

export default function YourInterestsView() {
	const { i18n } = useTranslation();

	// REQUIRED DATA FOR VIEW
	// profile
	const hasProfile = Boolean(useSelector(selectProfile));

	if (!hasProfile) {
		return <BookingFlowLoadingIndicator opaque />;
	}

	return (
		<ThemeContextProvider theme={THEMES.DARK}>
			<div className={`layout--profile ${i18n.dir(i18n.language)}`}>
				<div className="layout--profile-fullscreen profile-stay-preferences-view">
					<div className="view--profile">
						<YourInterests />
					</div>
				</div>
			</div>
		</ThemeContextProvider>
	);
}
